import { Environment } from "@internal/plugin-dev-services-chart-summary-common";

const caseInsensitiveObjectSort = <T>(key: keyof T) => {
  return (data1: T, data2: T): number => {
    const name1 = (data1[key] as string)?.toLowerCase();
    const name2 = (data2[key] as string)?.toLowerCase();

    if (name1 === name2) {
      return 0;
    }

    return name1 < name2 ? -1 : 1;
  };
};

export const buildVersionMap = (environments: Environment[]) => {
  const versionMap = new Map<string,string>();
    for (const environment of environments) {
      const storedVersion = versionMap.get(environment.class);
      if (storedVersion && !sortSemver(storedVersion, environment.chart.version)) {
        continue
      }

      versionMap.set(environment.class, environment.chart.version)   
    }
  return versionMap
}

const sortSemver = (a: string, b: string): number => {
  const splitSemver = (version: string) =>
    version
      ?.split('-')[0]
      ?.replace(/[^.\d]/g, '')
      ?.split('.');

  const semVerArray1 = splitSemver(a);
  const semVerArray2 = splitSemver(b);

  if (!semVerArray1) {
    return -1;
  }
  if (!semVerArray2) {
    return 1;
  }

  for (let i = 0; i < semVerArray1.length; i++) {
    const semVerInt1 = parseInt(semVerArray1[i], 10);
    const semVerInt2 = parseInt(semVerArray2[i], 10) ?? -1;

    if (semVerInt1 === semVerInt2) {
      continue;
    }

    return semVerInt1 < semVerInt2 ? -1 : 1;
  }

  return a.length < b.length ? -1 : 1;
};

const sortSemverByObjectKey = <T>(key: keyof T) => {
  return (a: T, b: T): number => {
    const version1 = a[key] as string;
    const version2 = b[key] as string;
    return sortSemver(version1, version2);
  };
};

const simpleFilterByObjectKey = <T>(key: keyof T) => {
  return (filter: any, rowData: T): boolean => {
    return (rowData[key] as string)
      ?.toLowerCase()
      .includes(filter?.toLowerCase());
  };
};

export { caseInsensitiveObjectSort, sortSemver, sortSemverByObjectKey, simpleFilterByObjectKey };
